import { Box, Grid, IconButton, Paper, Typography } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import { ArrowBackIosNewRounded, Newspaper } from '@mui/icons-material';
import { useTheme } from '@emotion/react';

const NewsDetailsNavbar = ({ handleNavigate }) => {
  const theme = useTheme();
  return (
    <Grid item xs={12} sx={{ height: '62px' }}>
      <Box
        component={Paper}
        elevation={0}
        sx={{
          p: 1,
          border: 1,
          borderColor: 'divider',
          background: variants.boxBackground.NAVBAR,
          borderRadius: variants.boxRadius.NAVBAR,
          display: 'flex',
        }}
      >
        <IconButton
          className='backButton'
          onClick={handleNavigate}
          sx={{
            p: 0,
            pr: 1,
            display: 'none',
            [theme.breakpoints.down('lg')]: {
              display: 'flex',
            },
          }}
        >
          <ArrowBackIosNewRounded fontSize='small' />
        </IconButton>

        <Grid item display={'flex'} justifyContent={'start'} alignItems={'center'}>
          <Newspaper sx={variants.icon.active} />
          <Typography component={'div'} ml={1} sx={{ fontSize: variants.BODY }}>
            News Details
          </Typography>
        </Grid>
      </Box>
    </Grid>
  );
};

export default NewsDetailsNavbar;
